import { render, staticRenderFns } from "./site-list.vue?vue&type=template&id=50245964"
import script from "./site-list.vue?vue&type=script&lang=js"
export * from "./site-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports